<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2021-01-05 00:40:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/category/firstproduct/index.vue
-->
<template>
  <div class="first">
    <title-bar-back :title="categoriesList[0].name" @back="back">
      <div class="mr_right"></div>
      <!-- <div>
        <img
          src="@/assets/common/icon_search_black@2x.png"
          alt=""
          class="title_img"
          @click="goSearch"
        />
        <img
          src="@/assets/common/icon_cart@2x.png"
          alt=""
          class="title_img mr"
        />
      </div> -->
    </title-bar-back>
    <!-- 分类切换 -->
    <two-switch
      v-if="
        categoriesList &&
          categoriesList[0] &&
          categoriesList[0].childrenCategories !== null &&
          categoriesList[0].childrenCategories.length > 1
      "
      @TwoSwitch="TwoSwitch"
    />
    <!-- 分类图 -->
    <div class="cate_all">
      <img
        :src="
          (categoriesList &&
            categoriesList[0] &&
            categoriesList[0].childrenCategories !== null &&
            categoriesList[0].childrenCategories[this.cateSwitchIndex]
              .bannerImg) ||
            categoriesList[0].bannerImg
        "
        alt=""
      />
    </div>
    <!-- 简介 -->
    <div
      v-if="
        (categoriesList &&
          categoriesList[0] &&
          categoriesList[0].childrenCategories !== null &&
          categoriesList[0].childrenCategories[this.cateSwitchIndex].resume) ||
          categoriesList[0].resume
      "
      class="bg_f"
    >
      <div class="cate_title">
        {{
          (categoriesList &&
            categoriesList[0] &&
            categoriesList[0].childrenCategories !== null &&
            categoriesList[0].childrenCategories[this.cateSwitchIndex].name) ||
            categoriesList[0].name
        }}
      </div>
      <div class="cate_title_det">
        {{
          (categoriesList &&
            categoriesList[0] &&
            categoriesList[0].childrenCategories !== null &&
            categoriesList[0].childrenCategories[this.cateSwitchIndex]
              .resume) ||
            categoriesList[0].resume
        }}
      </div>
    </div>
    <!-- 新品切换 -->
    <slot-switch @switchCate="switchCate" />
    <!-- 标签 -->
    <tag-list @switchTag="switchTag" />
    <!-- 底部商品 -->
    <recommend
      :productCon="searchProductList"
      :loadings="loadings"
      @onLoad="onLoad"
      @showPoster="showPosters"
    />
    <!-- 海报 -->
    <poster
      v-if="showPoster"
      :show="showPoster"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask v-if="showShareMask" @hideMask="hideMask" />
  </div>
</template>
<script>
import NativeShare from "nativeshare";
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then((m) => m.default || m);
import TwoSwitch from "./components/TwoSwitch";
import SlotSwitch from "./components/SlotSwitch";
import TagList from "./components/TagList";
const ShareMask = () =>
  import("../../mine/cardvoucher/components/ShareMask").then(
    (m) => m.default || m
  );
const Poster = () =>
  import("../../product/detail/components/Poster").then((m) => m.default || m);
const Recommend = () =>
  import("@/components/Recommend").then((m) => m.default || m);
export default {
  name: "FirstProduct",
  components: {
    TitleBarBack,
    TwoSwitch,
    SlotSwitch,
    Recommend,
    TagList,
    ShareMask,
    Poster,
  },
  data() {
    return {
      tagId: 0,
      categoryId: this.$route.query.categoryId,
      loadings: false,
      cateId: 0,
      cateSwitchIndex: 0,
      sort: "",
      direction: "",
      showPoster: false,
      showShareMask: false,
      posterItem: {},
    };
  },
  computed: {
    categoriesList() {
      return this.$store.getters.categoriesList;
    },
    searchProductList() {
      return this.$store.getters.searchProductList;
    },
    getSimpleUserInfo() {
      return this.$store.getters.getSimpleUserInfo;
    },
  },
  watch: {
    searchProductList: {
      handler(old, newValue) {
        console.log(old, newValue);
      },
      deep: true,
    },
    categoriesList: {
      handler(old, newValue) {
        console.log(old, newValue);
      },
      deep: true,
    },
  },
  created() {
    this.getData(this.categoryId);
    this.getUserData();
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 获取分类数据
    getData(id) {
      const params = {
        id,
        slug: this.slug,
      };
      this.$store
        .dispatch("product/queryCategories", { params })
        .then(() => {
          // 获取商品数据
          const params = {
            pageNo: 1,
            pageSize: 20,
            categoryId: this.categoryId,
            slug: this.slug,
          };
          this.getCateData(params);
        })
        .catch(() => {});
    },
    // // 刷新
    // onRefresh() {
    //   this.getData(this.categoryId);
    // },
    onLoad() {
      // console.log("上拉进行中");
      // this.loadings = false;
      if (
        this.searchProductList.hasNextPage &&
        this.searchProductList.pageNo <= this.searchProductList.pageCount &&
        !this.loadings
      ) {
        this.loadings = true;
        const pageIndex = this.searchProductList.pageNo + 1;
        const params = {
          pageNo: pageIndex,
          pageSize: 20,
          categoryId: this.categoryId,
        };
        if (this.tagId) {
          params.tradeType = this.tagId;
        }
        if (this.sort) {
          params.sort = this.sort;
        }
        if (this.direction) {
          params.direction = this.direction;
        }
        this.getCateData(params);
        // console.log("上拉完毕");
      }
    },
    //分类数据请求
    getCateData(params) {
      this.$store
        .dispatch("product/findClientRetailSpuByParam", {
          params,
        })
        .then(() => {
          this.loadings = false;
        })
        .catch(() => {
          this.loadings = false;
        });
    },
    // 海报获取用户数据
    getUserData() {
      this.$store
        .dispatch("mine/getSimpleUserInfo")
        .then(() => {})
        .catch(() => {});
    },
    // 三级分类切换
    TwoSwitch(index, name, id) {
      // console.log(index, name, id);
      this.cateSwitchIndex = index;
      // this.cateId = id;
      this.categoryId = id;
      const params = {
        pageNo: 1,
        pageSize: 20,
        categoryId: id,
        slug: this.slug,
      };
      this.getCateData(params);
    },
    // 新品价格切换
    switchCate(index, newSlot, priceSlot) {
      const params = {
        pageNo: 1,
        pageSize: 20,
        categoryId: this.categoryId,
        slug: this.slug,
      };
      if (newSlot) {
        this.sort = "gmtCreate";
        this.direction = newSlot;
        params.sort = "gmtCreate";
        params.direction = newSlot;
      }
      if (priceSlot) {
        this.sort = "storePrice";
        this.direction = priceSlot;
        params.sort = "storePrice";
        params.direction = priceSlot;
      }
      this.getCateData(params);
    },
    // 切换标签
    switchTag(index, id) {
      // console.log(id, "标签");
      const params = {
        pageNo: 1,
        pageSize: 20,
        categoryId: this.categoryId, //分类id
        slug: this.slug,
      };
      if (id !== -1) {
        this.tagId = id;
        params.tradeType = id; //贸易类型  0-直邮  1-保税区  2- 一般贸易
      }
      this.getCateData(params);
    },
    // 搜索跳转
    goSearch() {
      this.$router.push("/search");
    },
    showPosters(productDetail) {
      this.posterItem = productDetail;
      this.showPoster = true;
    },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      return isWeixin;
    },
    openShare() {
      // console.log(typeof NativeShare);
      // console.log(NativeShare, 88888);
      if (typeof NativeShare !== "undefined") {
        // console.log(111);
        if (this.isWechatBrowser()) {
          // console.log(222);
          this.showPoster = false;
          this.showShareMask = true;
        } else {
          this.$toast("需要在微信浏览器分享哦！");
        }
      } else {
        this.showPoster = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.first {
  // background: #fff;
  .title_img {
    width: 24px;
  }
  .mr {
    margin-left: 12px;
  }
  .cate_all {
    img {
      width: 100%;
      max-height: 120px;
      display: block;
    }
  }
  .bg_f {
    margin-bottom: 12px;
  }
  .cate_title {
    padding-top: 12px;
    font-size: 16px;
    font-weight: 400;
    color: #000;
    line-height: 22px;
  }
  .cate_title_det {
    padding: 8px 18px 0;
    font-size: 12px;
    font-weight: 400;
    color: #000;
    line-height: 17px;
    // text-align: left;
  }
}
</style>
